export default __webpack_public_path__ + "static/media/PSC_Peer_Feedback_Template_Sample.95dcabb1.xlsx";